import { Component, OnInit } from '@angular/core';

/** I created this to maybe be an on-exchange equivalent of the plan-enrollment.component.ts
 * but, I might be just using that one, if this remains unpopulated, don't bother to commit
 */
@Component({
    selector: 'app-plan-enrollment-on-exchange',
    templateUrl: './plan-enrollment-on-exchange.component.html',
    styleUrls: ['./plan-enrollment-on-exchange.component.scss'],
    standalone: false
})
export class PlanEnrollmentOnExchangeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
